import {chainWalk} from "../util/Util";
import {CORE_CYCLE_PREFIX, EMPTY_STRING_PLACEHOLDER, DELIMITER, SETTINGS_TYPE} from "./Constants";

/**
 * This method returns the time window string for a given time window object
 * @returns string
 */
export const getWindowString = (window) => {
    let st_hr  = chainWalk(() => window.startTime.hour.toString().padStart(2, '0'), EMPTY_STRING_PLACEHOLDER)
    let st_min = chainWalk(() => window.startTime.minute.toString().padStart(2, '0'), EMPTY_STRING_PLACEHOLDER)
    let en_hr  = chainWalk(() => window.endTime.hour.toString().padStart(2, '0'), EMPTY_STRING_PLACEHOLDER)
    let en_min = chainWalk(() => window.endTime.minute.toString().padStart(2, '0'), EMPTY_STRING_PLACEHOLDER)
    return `${st_hr}:${st_min}-${en_hr}:${en_min}`
}

/**
 * Returns a list of cycle names in the following order:
 * First, a lexicographically ordered list of core cycle names
 * Followed by a lexicographically ordered list other cycle names
 * @returns string[]
 */
export const orderCycles = (cycleNames) => {
    const core_cycles = []
    const other_cycles = []
    cycleNames.forEach((name) => {
        if (name.startsWith(CORE_CYCLE_PREFIX)) {
            core_cycles.push(name)
        } else {
            other_cycles.push(name)
        }
    })
    core_cycles.sort()
    other_cycles.sort()
    return core_cycles.concat(other_cycles);
}

/**
 * Builds the settings name by combining cycle, stationCode, and settingsType with a delimiter.
 * @param {string} cycle - The cycle name
 * @param {string} stationCode - The station code
 * @returns {string} The formatted settings name
 */
export const buildSettingsName = (cycle, stationCode) => cycle + DELIMITER + stationCode + DELIMITER + SETTINGS_TYPE;



// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/Utils.js